import http from '@/api/http';
import type { ShippingDirection } from '@/contexts/DirectionContext';
import type { PortTransitTimeRow } from '../interfaces/portTransitTimes.interface';

export const portTransitTimesApi = {
  async get(companyId?: number, direction?: ShippingDirection): Promise<PortTransitTimeRow[]> {
    const params: Record<string, string | number> = {};
    if (typeof companyId === 'number') params.companyId = companyId;
    if (direction) params.direction = direction;
    const response = await http.get('/dashboard/port-transit-times', { params });
    return (response.data?.data as PortTransitTimeRow[]) ?? [];
  },
};
